var map = {
	"./Group 22302.png": 1058,
	"./avatar-christmas.webp": 1059,
	"./bottom-bg-christmas.webp": 1060,
	"./btn-active.png": 1061,
	"./content-deco-1.webp": 1062,
	"./content-deco-2.webp": 1063,
	"./content-deco-3.webp": 1064,
	"./content-deco-4.webp": 1065,
	"./deco-3.webp": 1066,
	"./deposit-icon.webp": 1067,
	"./home-icon-active.webp": 1068,
	"./home-icon.webp": 1069,
	"./live-icon-active.webp": 1070,
	"./live-icon.webp": 1071,
	"./master-bg.jpg": 1072,
	"./master-bg.webp": 1073,
	"./me-icon-active.webp": 1074,
	"./me-icon.webp": 1075,
	"./platform.png": 1076,
	"./platform.webp": 1077,
	"./promos-icon-active.webp": 1078,
	"./promos-icon.webp": 1079,
	"./promos.webp": 1080,
	"./service-christmas.webp": 1081,
	"./snowman.webp": 1082,
	"./sponsor-icon-active.webp": 1083,
	"./sponsor-icon.webp": 1084,
	"./title-deco-left.webp": 1085,
	"./title-deco-right.webp": 1086,
	"./tree.webp": 1087,
	"./vip-icon.webp": 1088,
	"./vip.webp": 1089,
	"./withdraw-icon.webp": 1090,
	"./wwr-img.webp": 1091
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 107;